import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { IPagePanel } from "../common/pagePanel";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { RecordPagePanel } from "./recordPagePanel";
import { IRecordCompanyFurtherEducationGroups, RecordCompanyFurtherEducationGroups } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";
import { IRecordCompanyRecordFamiliarizationListItems, RecordCompanyRecordFamiliarizationListItems } from "./recordCompanyRecordFamiliarizationListItems";

export interface IRecordPageList {
    hasExplicitRecordPartners: boolean;
    panels: IPagePanel[];
    companies: ICompanyMenuItem[];
    companyFurtherEducationGroups: IRecordCompanyFurtherEducationGroups[];
    companyFamiliarizations: IRecordCompanyRecordFamiliarizationListItems[];
    units: IIdTitleNode[];
    jobTitles: string[];
    sheetTaskType: ITaskEditTypeItem;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class RecordPageList implements IRecordPageList {
    hasExplicitRecordPartners: boolean;
    panels: RecordPagePanel[];
    companies: CompanyMenuItem[];
    companyFurtherEducationGroups: RecordCompanyFurtherEducationGroups[];
    companyFamiliarizations: RecordCompanyRecordFamiliarizationListItems[];
    units: IdTitleNode[];
    jobTitles: string[];
    sheetTaskType: TaskEditTypeItem;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: IRecordPageList);
    constructor(obj?: any) {
        this.hasExplicitRecordPartners = obj && obj.hasExplicitRecordPartners || false;
        this.panels = Base.getTypedArray(obj?.panels, RecordPagePanel);
        this.companyFurtherEducationGroups = Base.getTypedArray(obj?.companyFurtherEducationGroups, RecordCompanyFurtherEducationGroups);
        this.companyFamiliarizations = Base.getTypedArray(obj?.companyFamiliarizations, RecordCompanyRecordFamiliarizationListItems);
        this.companies = Base.getTypedArray(obj?.companies, CompanyMenuItem);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.jobTitles = obj && obj.jobTitles || [];
        this.sheetTaskType = null;
        if (obj?.sheetTaskType) {
            this.sheetTaskType = new TaskEditTypeItem(obj.sheetTaskType);
        }
        this.companyFilters = Base.getTypedArray(obj?.companyFilters, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj?.userFilters, SavedListFilter);
    }
}